import email from "../assets/email.png";
import mobile from "../assets/mobile.png";

import css from "../assets/css.png";

import git from "../assets/git.png";

import html from "../assets/html.png";
import javascript from "../assets/javascript.png";

import react from "../assets/react.png";

import sass from "../assets/sass.png";
import typescript from "../assets/typescript.png";

import profile from "../assets/profile.png";
import circle from "../assets/circle.svg";
import logo from "../assets/logo.png";

import greenCircle from "../assets/greenCircle.gif";

import firebase from "../assets/firebase.png";
import tailwind from "../assets/tailwind.png";
import fooddeliveryapp from "../assets/fooddeliveryapp.png";
import alexaportfolio from "../assets/alexaportfolio.png";
import fineDining from "../assets/fineDining.png";
import fruitsDeliveryApp from "../assets/fruitsDeliveryApp.png";
import gpt3 from "../assets/gpt3.png";
import loremIpsum from "../assets/loremIpsum.png";
import modernBank from "../assets/modernBank.png";
import nextGeneration from "../assets/nextGeneration.png";
import personalPortfolio from "../assets/personalPortfolio.png";
import todoListApp from "../assets/todoListApp.png";
import framerMotion from "../assets/framerMotion.png";
import javasCriptOne from "../assets/javaScriptOne.png";
import firebaseOne from "../assets/firebaseOne.png";
import reactOne from "../assets/reactOne.png";
import framerMotionOne from "../assets/framerMotionOne.png";
import shopifyImage from "../assets/shopifyimage.png";
import liquidImage from "../assets/liquidimage.png";
import shopifyAboutOne from "../assets/shopifyAboutOne.webp"
import shopifyAboutTwo from "../assets/shopifyAboutTwo.png"
import shopifyAboutThree from "../assets/shopifyAboutThree.png"
import shopifyAboutFour from "../assets/shopifyAboutFour.jpg"
import figmaIconSkill from "../assets/figmaIconSkill.png"
import fashionForwardStore from "../assets/fashionForwardStore.jpg"
import palmpressImg from "../assets/palmPressImg.jpg"
import fybelleStore from "../assets/fybelleStore.jpg"



import MyResume from "../assets/CV/MyResume.pdf";


export default {
  MyResume,
  framerMotionOne,
  firebaseOne,
  reactOne,
  javasCriptOne,
  framerMotion,
  todoListApp,
  alexaportfolio,
  fineDining,
  nextGeneration,
  personalPortfolio,
  fruitsDeliveryApp,
  fooddeliveryapp,
  loremIpsum,
  modernBank,
  gpt3,
  firebase,
  tailwind,
  greenCircle,
  email,
  mobile,

  css,

  git,

  html,
  javascript,

  react,

  sass,
  typescript,

  profile,
  circle,
  logo,
  shopifyImage,
  liquidImage,

  shopifyAboutOne,
  shopifyAboutTwo,
  shopifyAboutThree,
  shopifyAboutFour,
  figmaIconSkill,

  fashionForwardStore,
  palmpressImg,
  fybelleStore


};
